export class UserOwnedProjectModel {
    constructor() {
        this.projectDisplayString = "";
        this.projectMembers = [];
        this.selected = false;
    }
}
export default class UserOwnedProject extends UserOwnedProjectModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
